import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import AnonymousBlankSlate from 'modules/surveys/components/Analytics/AnonymousBlankSlate'
import BlankSlate from 'modules/surveys/components/Analytics/_BlankSlate'
import FilteredBlankSlate from 'modules/surveys/components/Analytics/_FilterBlankSlate'
import { useAnalytics } from 'modules/surveys/pages/Show/hooks'

import QuestionHeadCell from './_QuestionHeadCell'
import SurveyRow from './_SurveyRow'

const ANONYMOUS_PLACEHOLDER = '-'

interface Props {
  isFilterApplied: boolean
}

const TableResults = ({ isFilterApplied }: Props) => {
  const { analyticResult, cycle, form } = useAnalytics()
  const isAnonymous = form.isAnonymous

  track('Survey results view')
  if (isAnonymous && !analyticResult) return <AnonymousBlankSlate />

  if (!analyticResult && isFilterApplied) return <FilteredBlankSlate />

  if (!analyticResult) return <BlankSlate />

  return (
    <Box overflowX="scroll">
      <Table
        style={{ minWidth: '100%', width: 'min-content' }}
        options={() => (
          <Box flexDirection="row" gap="s8" flexGrow alignItems="center">
            <Text.Normal weight="medium">{form.attributes.name}</Text.Normal>
          </Box>
        )}
      >
        <Table.Head>
          <Table.Row>
            {!isAnonymous && (
              <Table.HeadCell width={180}>
                {i18n.t('surveys.form.participants.title')}
              </Table.HeadCell>
            )}
            {Array.from(analyticResult.questions).map((question: any) => (
              <QuestionHeadCell key={question.id} label={question.label} />
            ))}
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {analyticResult.questionGroupsInCycle(cycle).map((questionGroup: any) => {
            const participantUser = users.get(questionGroup.participant_id)
            const participantFullName = participantUser
              ? getFullDisplayName({
                  firstName: participantUser.attributes.first_name,
                  lastName: participantUser.attributes.last_name,
                })
              : undefined

            return (
              <SurveyRow
                key={questionGroup.id}
                participantFullName={participantFullName || ANONYMOUS_PLACEHOLDER}
                answers={questionGroup.answers}
                questionIds={analyticResult.questionIds}
                isAnonymous={isAnonymous}
              />
            )
          })}
        </Table.Body>
      </Table>
    </Box>
  )
}

export default observer(TableResults)
